import { render, staticRenderFns } from "./ConcentradorInfo.vue?vue&type=template&id=55df1b91&scoped=true"
import script from "./ConcentradorInfo.vue?vue&type=script&lang=js"
export * from "./ConcentradorInfo.vue?vue&type=script&lang=js"
import style0 from "./ConcentradorInfo.vue?vue&type=style&index=0&id=55df1b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df1b91",
  null
  
)

export default component.exports